'use strict';
import angular from 'angular';
import PageLevelAlertMessagingController from './page-level-alert-messaging.controller';
import PageLevelAlertMessagingService from './page-level-alert-messaging.service';
export default angular.module('directives.pageLevelAlertMessaging', [])
    .service('PageLevelAlertMessagingService', PageLevelAlertMessagingService)
    .controller('PageLevelAlertMessagingController', PageLevelAlertMessagingController)
    .component('pageLevelAlertMessaging', {
    template: require('./page-level-alert-messaging.html'),
    controller: PageLevelAlertMessagingController,
    bindings: {
        message: '<',
        messageType: '<'
    }
})
    .directive('scrollPosition', ['$window', 'PageLevelAlertMessagingService', function ($window, PageLevelAlertMessagingService) {
        return {
            restrict: 'A',
            scope: {
                scrollClass: "@"
            },
            link: function (scope, element) {
                function addFixedClass(showIf) {
                    if (showIf) {
                        element.addClass(scope.scrollClass);
                    }
                    else {
                        element.removeClass(scope.scrollClass);
                    }
                }
                addFixedClass(!element[0].hidden);
                var offsetTopValue = angular.element(document.querySelectorAll('#navbar'))['0'].offsetTop;
                var pageScrollOffset = angular.element($window)['0'].pageYOffset;
                var alertTopPosition = 0;
                if (offsetTopValue > pageScrollOffset && !PageLevelAlertMessagingService.isModalOpen) {
                    var value = offsetTopValue - pageScrollOffset;
                    alertTopPosition = value + 'px';
                }
                angular.element(document.querySelectorAll('#page-scroll-fix')).css('top', alertTopPosition);
                angular.element($window).bind("scroll", function () {
                    angular.element(document.querySelectorAll('#page-scroll-fix')).css('top', '');
                    addFixedClass(this.pageYOffset >= 320);
                });
            }
        };
    }])
    .name;
//# sourceMappingURL=index.js.map